import React from 'react';
import ArchitectureBlock from '../ArchitectureBlock';
import { BMC_BLOCKS } from '../../common_components/bmc/bmc_constants';
import { LEAN_BLOCKS } from '../constants';
import { Layer, Stage, Group, Line, Text, Arrow } from 'react-konva';
import { injectIntl } from 'react-intl';
import { inject, observer } from 'mobx-react';

function ActivityArchitectureMobile({ history }) {
  const width = 360;
  const height = 640;
  return (
    <div className="architecture-block-container">
      <Stage width={width} height={height}>
        <Layer>
          <KeyActivityGraphicMobile width={width} history={history} />
        </Layer>
      </Stage>
    </div>
  );
}

@injectIntl
@inject('rootStore')
@observer
class KeyActivityGraphicMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = { cardDescriptionHeight: 0 };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.history.push(
      this.props.rootStore.blockPath(BMC_BLOCKS.KEY_ACTIVITIES)
    );
  }

  getArrowColor(val) {
    return val > 0 ? '#7BA3D3' : '#ddd';
  }

  getPositions() {
    const marginy = 35,
      marginx = 23;
    const prueba = 80,
      prueba2 = 166,
      prueba3 = 64,
      prueba4 = 29;
    const revenues = { x: marginx, y: marginy };
    const measure = { x: revenues.x + prueba, y: revenues.y };
    const activity = { x: measure.x + prueba, y: revenues.y };
    const proposition = { x: activity.x + prueba, y: revenues.y };
    const resources = { x: marginx, y: revenues.y + prueba2 };
    const customers = { x: resources.x + prueba, y: resources.y };
    const channels = { x: customers.x + prueba, y: resources.y };
    const relations = { x: channels.x + prueba, y: resources.y };
    const partners = { x: marginx, y: relations.y + prueba2 };
    const costs = { x: partners.x + prueba, y: partners.y };
    const learn = { x: costs.x + prueba, y: partners.y };
    const build = { x: learn.x + prueba, y: partners.y };

    const blocks = {
      revenue: revenues,
      measure: measure,
      activity: activity,
      proposition: proposition,
      resources: resources,
      customers: customers,
      channels: channels,
      relations: relations,
      partners: partners,
      costs: costs,
      learn: learn,
      build: build
    };

    const lines = {
      line1: { x: revenues.x + prueba3, y: revenues.y + prueba4 },
      line2: { x: measure.x + prueba3, y: measure.y + prueba4 },
      line3: { x: activity.x + prueba3, y: activity.y + prueba4 },
      line4: { x: resources.x + prueba3, y: resources.y + prueba4 },
      line5: { x: customers.x + prueba3, y: customers.y + prueba4 },
      line6: { x: channels.x + prueba3, y: channels.y + prueba4 },
      line7: { x: partners.x + prueba3, y: partners.y + prueba4 },
      line8: { x: costs.x + prueba3, y: costs.y + prueba4 },
      line9: { x: learn.x + prueba3, y: learn.y + prueba4 }
    };

    const arrows = {
      arrow1: {
        x1: activity.x + prueba3 + 120 * 0.53,
        y1: activity.y + prueba4,
        x2: activity.x + prueba3 + 180 * 0.53,
        y2: activity.y + prueba4,
        x3: activity.x + prueba3 + 180 * 0.53,
        y3: activity.y + prueba4 + 220 * 0.53
      },
      arrow2: {
        x1: resources.x + prueba3 - 30 * 0.53,
        y1: resources.y + prueba4,
        x2: resources.x + prueba3 - 121 * 0.53,
        y2: resources.y + prueba4,
        x3: resources.x + prueba3 - 121 * 0.53,
        y3: resources.y + prueba4 + 220 * 0.53
      }
    };

    const dimensions = {
      smallWidth: 150 * 0.53,
      smallHeight: 110 * 0.53,
      lineStrokeWidth: 3 * 0.53
    };

    return { blocks, lines, arrows, dimensions };
  }

  renderLines(positions, strokeColor) {
    const { lineStrokeWidth } = positions.dimensions;
    return Object.keys(positions.lines).map((key, index) => (
      <Line
        key={`line-${index}`}
        x={positions.lines[key].x}
        y={positions.lines[key].y}
        points={[0, 0, 60 * 0.53, 0]}
        stroke={strokeColor}
        strokeWidth={lineStrokeWidth}
        lineCap="round"
        lineJoin="round"
      />
    ));
  }

  renderArrows(positions) {
    const arrowDefaults = {
      stroke: '#d0d0d0',
      strokeWidth: 10 * 0.53,
      pointerLength: 13 * 0.53,
      pointerWidth: 17 * 0.53,
      lineCap: 'butt',
      lineJoin: 'miter'
    };

    return (
      <>
        <Arrow
          points={[
            positions.arrows.arrow1.x1,
            positions.arrows.arrow1.y1,
            positions.arrows.arrow1.x2,
            positions.arrows.arrow1.y2,
            positions.arrows.arrow1.x3,
            positions.arrows.arrow1.y3
          ]}
          {...arrowDefaults}
        />
        <Arrow
          points={[
            positions.arrows.arrow2.x1,
            positions.arrows.arrow2.y1,
            positions.arrows.arrow2.x2,
            positions.arrows.arrow2.y2,
            positions.arrows.arrow2.x3,
            positions.arrows.arrow2.y3
          ]}
          {...arrowDefaults}
        />
      </>
    );
  }

  renderBlocks(positions) {
    const { smallWidth, smallHeight } = positions.dimensions;
    const { rootStore, history } = this.props;
    const disableLearnBuild = rootStore.disableLearnBuildBlocks;
    const blockConfigs = [
      {
        block: BMC_BLOCKS.REVENUE_STREAMS,
        pos: positions.blocks.revenue,
        step: 1
      },
      { block: LEAN_BLOCKS.MEASURE, pos: positions.blocks.measure, step: 2 },
      {
        block: BMC_BLOCKS.KEY_ACTIVITIES,
        pos: positions.blocks.activity,
        step: 3
      },
      {
        block: BMC_BLOCKS.KEY_PROPOSITIONS,
        pos: positions.blocks.proposition,
        step: 4
      },
      {
        block: BMC_BLOCKS.CUSTOMER_RELATIONSHIPS,
        pos: positions.blocks.relations,
        step: 5
      },
      { block: BMC_BLOCKS.CHANNELS, pos: positions.blocks.channels, step: 6 },
      {
        block: BMC_BLOCKS.CUSTOMER_SEGMENTS,
        pos: positions.blocks.customers,
        step: 7
      },
      {
        block: BMC_BLOCKS.KEY_RESOURCES,
        pos: positions.blocks.resources,
        step: 8
      },
      {
        block: BMC_BLOCKS.KEY_PARTNERS,
        pos: positions.blocks.partners,
        step: 9
      },
      {
        block: BMC_BLOCKS.COST_STRUCTURE,
        pos: positions.blocks.costs,
        step: 10
      },
      {
        block: LEAN_BLOCKS.LEARN,
        pos: positions.blocks.learn,
        step: 11,
        disabled: true
      },
      {
        block: LEAN_BLOCKS.BUILD,
        pos: positions.blocks.build,
        step: 12,
        disabled: true
      }
    ];

    return blockConfigs.map(config => (
      <ArchitectureBlock
        key={config.step}
        history={history}
        block={config.block}
        x={config.pos.x}
        y={config.pos.y}
        width={smallWidth}
        height={smallHeight}
        stepNumber={config.step}
        isMobile={true}
        {...(config.disabled ? { disabled: disableLearnBuild } : {})}
      />
    ));
  }

  renderActivity() {
    const { width, rootStore } = this.props;
    const block = BMC_BLOCKS.KEY_ACTIVITIES;
    const cards = rootStore.activityStore.activityEdit.getSelectedCardsByBlock(
      block
    );
    let fillColor = '#ddd';
    let textColor = '#555';
    if (cards[0]) {
      fillColor = '#6883A4';
      textColor = 'white';
    }
    if (block === rootStore.igBusinessStore.currentBlock) {
      fillColor = '#0fa69a';
      textColor = 'white';
    }
    return (
      <Group>
        <Text
          ref="description"
          x={10}
          y={60}
          width={this.props.width}
          align="left"
          fontSize={16 * 0.53}
        />
      </Group>
    );
  }

  componentDidMount() {
    this.setState({
      cardDescriptionHeight: this.refs.description.getHeight()
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const nextHeight = this.refs.description.getHeight();
    if (this.state.cardDescriptionHeight !== nextHeight) {
      this.setState({ cardDescriptionHeight: nextHeight });
    }
  }

  render() {
    const positions = this.getPositions();
    return (
      <Group>
        {this.renderActivity()}
        {this.renderLines(positions, '#0fa69a')}
        {this.renderArrows(positions)}
        {this.renderBlocks(positions)}
      </Group>
    );
  }
}

export default ActivityArchitectureMobile;
